<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_ctw" transform="translate(1509 2999)">
      <path
        id="패스_3848"
        data-name="패스 3848"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1509 -2999)"
      />
      <g
        id="그룹_8353"
        data-name="그룹 8353"
        transform="translate(-4.062 0.19)"
      >
        <circle
          id="타원_733"
          data-name="타원 733"
          fill="#d5d8dc"
          cx="9"
          cy="9"
          r="9"
          transform="translate(-1502 -2995)"
        />
        <rect
          id="사각형_5798"
          data-name="사각형 5798"
          fill="#087ef7"
          width="2"
          height="6"
          transform="translate(-1488.938 -2995.658) rotate(-50)"
        />
        <rect
          id="사각형_5799"
          data-name="사각형 5799"
          fill="#087ef7"
          width="2"
          height="6"
          transform="translate(-1501.652 -2991.801) rotate(-130)"
        />
        <path
          id="패스_4052"
          data-name="패스 4052"
          fill="#363c43"
          d="M12.5,8H11v6l4.75,2.85.75-1.23-4-2.37Z"
          transform="translate(-1504.938 -2999.19)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
